import { graphql } from '@/gql';
import { SmsRecipientName } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendOperatorTextMessage = async ({
  phoneNumber,
  rideId,
  message,
  recipientType,
  associatedCallerId,
  customerName,
  operatorName,
  customerRegisteredNumber,
}: {
  phoneNumber?: string | null;
  rideId?: number | null;
  message: string;
  recipientType: SmsRecipientName;
  associatedCallerId?: string | null;
  customerName?: string | null;
  operatorName?: string | null;
  customerRegisteredNumber?: string | null;
}): Promise<boolean> => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      rideId,
      message,
      recipientType,
      associatedCallerId,
      customerName,
      operatorName,
      customerRegisteredNumber,
    },
    mutation: graphql(`
      mutation SendOperatorTextMessage(
        $phoneNumber: String
        $rideId: Int
        $message: String!
        $recipientType: SmsRecipientName!
        $associatedCallerId: String
        $customerName: String
        $operatorName: String
        $customerRegisteredNumber: String
      ) {
        sendOperatorTextMessage(
          phoneNumber: $phoneNumber
          rideId: $rideId
          message: $message
          recipientType: $recipientType
          associatedCallerId: $associatedCallerId
          customerName: $customerName
          operatorName: $operatorName
          customerRegisteredNumber: $customerRegisteredNumber
        )
      }
    `),
  });

  return response.data?.sendOperatorTextMessage ?? false;
};
